<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <template #end>
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`待审核合同订单列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">

      <!-- 标记 -->
      <template slot="is_mark" slot-scope="params">
        <MySwitch :keyName="'isMark'" :data="params.params" :activeValue="'1'" :inactiveValue="`0`"
          @onToggle="toggleMark"></MySwitch>
      </template>

      <!-- 订单编号 -->
      <template #orderNum="params">
        <div class="orderNum" :class="params.params.is_reject == 1 ? 'tui' : ''">
          {{ params.params.order_num }}
        </div>
      </template>

      <!-- 队长审核状态 -->
      <template slot="status" slot-scope="params">
        <span class="status status0" v-if="params.params.isfleet == 1">未审核</span>
        <span class="status status1" v-if="params.params.isfleet == 2">已审核</span>
      </template>

      <!-- 经理审核状态 -->
      <template slot="is_manager" slot-scope="params">
        <span class="status status0" v-if="params.params.is_manager == 1">未审核</span>
        <span class="status status1" v-if="params.params.is_manager == 2">已审核</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      formInline: {
        ischeck: 1,
        isstatus: 5,
      },
      formCtrl: [],
      cols: [
        { prop: "order_num", label: "订单编号", width: 200, slot: 'orderNum' },
        { prop: "fleet_nickname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机", minwidth: 120 },
        { prop: "name", label: "货物名称", minwidth: 120 },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
      ],
      btns: [
        {
          ...this.feeBtn,
          cb: ({ id, isstatus }) => {
            console.log(id)
            let mode = 'view'
            if ([3, 4].includes(isstatus) && [5].includes(this.user.user_group_id)) {
              mode = 'edit'
            }
            this.$router.push(
              `/order/contractfee?id=${id}&mode=${mode}`
            );
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/contractview3?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() {
    const { user_group_id, id } = this.user
    if ([1].includes(user_group_id)) {
      if (id == 1) {
        this.cols.push({
          prop: "isfleet",
          label: "车队长审核状态",
          slot: 'status',
          width: 120,
        })
        this.cols.push({
          prop: "is_manager",
          label: "经理审核状态",
          slot: 'is_manager',
          width: 120,
        })
        this.btns.push({
          ...this.delBtn,
          cb: ({ order_num }) => {
            this.delete(order_num)
          },
        })
      }
      if ([17].includes(id)) {
        this.cols.push({
          prop: "isMark",
          label: "已处理",
          slot: 'is_mark'
        })
      }
    }
    if ([2, 3, 4].includes(user_group_id) && [646].includes(id)) {
      this.cols.push({
        prop: "isMark",
        label: "已处理",
        slot: 'is_mark'
      })
    }
    if ([1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns[1] = {
        ...this.editBtn,
        cb: ({ id, isstatus, isover }) => {
          console.log(id, isstatus)
          let path = 'contractview'
          let mode = 'view'
          if (isstatus == 4) {
            path = 'contractview4'
            mode = 'edit'
          } else if (isstatus == 3 && isover == 2) {
            path = 'contractview5'
            // 经理纯查看
            if (this.user.user_group_id != 1 || this.user.id == 1) mode = 'edit'
          }
          this.$router.push(
            `/order/${path}?id=${id}&mode=${mode}`
          );
        },
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  .table-wrap {
    /deep/ .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tui {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../../../../assets/img/icon_reject.png) no-repeat center center;
          background-size: 20px;
        }
      }

      .status {
        &.status1 {
          color: #98e098;
        }

        &.status0 {
          color: #fd5b5b;
        }
      }
    }
  }
}
</style>
